import type { ClientCategorisation } from '@/constants';
import type { Country, CountryProductType } from '@/services/api/mainstream/countries';

const FUTURES_PRODUCT_TYPES: CountryProductType[] = ['DATED_FUTURE', 'EQUITY_FUTURE'];

export const isFuturesAllowedForCountryAndCategorisation = (country: Country | undefined, categorisation: ClientCategorisation): boolean => {
  const allowedProducts = country?.allowedProducts?.[categorisation];
  if (!allowedProducts) return false;

  return allowedProducts.some((product) => FUTURES_PRODUCT_TYPES.includes(product));
};
